import React from 'react';

function FormError(props) {
    return (
        <React.Fragment>
            {(props['errors'][props['campo']] && props['touched'][props['campo']]) &&
                <div className="help-block">
                    <div className="error">{props['errors'][props['campo']]}</div>
                </div>}
        </React.Fragment>
    )
}

function FormGroup(props) {
    return (
        <div className={(props.className ? props.className : "form-group col-sm-6 col-sm-offset-3") + " " + (props.errors[props.campo] && props.touched[props.campo] ? 'has-error' : '')}>
            {props.children}
            <FormError {...props} />
        </div>
    );
}

export { FormError, FormGroup }